var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Analysis',{attrs:{"project":_vm.vid,"embed":"","data-testid":"analysis-component"}})
}
var staticRenderFns = []

export { render, staticRenderFns }